import { useAuthStore } from "../stores/authStore";
import { deviceRoot } from "../vue-client";

export async function calibrationCallFunction(param, functionName, slotId, enableLogging = true) {
    const authStore = useAuthStore();
    let authString = "Bearer " + authStore.authUser.authToken;
    
    const requestData = {
        function: functionName,
        param: param,
    };
    
    if (enableLogging) {
        console.log(`📡 API Call: ${functionName}`, {
            slotId,
            param,
            timestamp: new Date().toISOString(),
            url: `${deviceRoot}/functions/${slotId}`
        });
    }
    
    const startTime = performance.now();
    
    try {
        const response = await fetch(`${deviceRoot}/functions/${slotId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: authString,
            },
            body: JSON.stringify(requestData),
        });
        
        const endTime = performance.now();
        const duration = endTime - startTime;
        
        if (enableLogging) {
            const responseInfo = {
                status: response.status,
                statusText: response.statusText,
                ok: response.ok,
                duration: `${duration.toFixed(2)}ms`,
                headers: Object.fromEntries(response.headers.entries())
            };
            
            console.log(`📡 API Response: ${functionName}`, responseInfo);
            
            // Try to log response body without consuming it
            const clonedResponse = response.clone();
            try {
                const responseText = await clonedResponse.text();
                console.log(`📡 API Response Body: ${functionName}`, responseText);
            } catch (bodyError) {
                console.log(`📡 API Response Body: ${functionName} - Could not read body`);
            }
        }
        
        return response;
        
    } catch (error) {
        const endTime = performance.now();
        const duration = endTime - startTime;
        
        if (enableLogging) {
            console.error(`❌ API Error: ${functionName}`, {
                error: error.message,
                duration: `${duration.toFixed(2)}ms`,
                slotId,
                param
            });
        }
        
        throw error;
    }
}

export async function callCalibarationAwakeFunction(minutes, slotId) {
    const response = await calibrationCallFunction(minutes, 'calAwakeMins', slotId);
    if (response.ok === true) {
        return `StayAwakeMin ${minutes} completed`;
    }
    else {
        const errorText = await response.text();
        return `StayAwakeMin ${minutes} failed. Error=${errorText}`;
    }
}

export async function pingDevice(slotId, enableLogging = true) {
    const authStore = useAuthStore();
    let authString = "Bearer " + authStore.authUser.authToken;
    
    if (enableLogging) {
        console.log(`🏓 Ping Device`, {
            slotId,
            timestamp: new Date().toISOString(),
            url: `${deviceRoot}/slots/${slotId}/ready`
        });
    }
    
    const startTime = performance.now();
    
    try {
        const response = await fetch(`${deviceRoot}/slots/${slotId}/ready`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: authString,
            }
        });
        
        const endTime = performance.now();
        const duration = endTime - startTime;
        
        const responseJson = await response.json();
        
        if (enableLogging) {
            console.log(`🏓 Ping Response`, {
                status: response.status,
                ok: response.ok,
                duration: `${duration.toFixed(2)}ms`,
                ready: responseJson.ready,
                data: responseJson
            });
        }
        
        return responseJson;
        
    } catch (error) {
        const endTime = performance.now();
        const duration = endTime - startTime;
        
        if (enableLogging) {
            console.error(`❌ Ping Error`, {
                error: error.message,
                duration: `${duration.toFixed(2)}ms`,
                slotId
            });
        }
        
        throw error;
    }
}

/**
 * 
 * @param rgbOption 0: R. 1: G. 2: B.
 * @param slotId string
 */
export async function callCalibrationFunction(rgbOption, slotId) {
    const response = await calibrationCallFunction(rgbOption, 'calRGB', slotId);
    if (response.ok === true) {
        return `Calibration completed`;
    }
    else {
        const errorText = await response.text();
        return `Calibration failed. Error=${errorText}`;
    }
}